module.exports = __webpack_public_path__ + "static/media/play.1daf7b0d.svg";